<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          @click="onclickCoppy()"
          :size="size"
          :color="color"
          >mdi-content-copy</v-icon
        >
      </template>
      <span>Sao chép</span>
    </v-tooltip>

    <v-snackbar color="#3C88EE" v-model="snackbar" centered top>
      {{ contentCopySuccess }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Đóng
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true,
    },
    size: {
      default: "small",
    },
    color: {
      default: "",
    },
    contentCopySuccess: {
      default: "Sao chép thành công!",
    },
  },
  data() {
    return {
      snackbar: false,
    }
  },
  methods: {
    onclickCoppy() {
      this.snackbar = true
      navigator.clipboard.writeText(this.value)
    },
  },
}
</script>